<template>
  <div class="whatsapp-associacoes">
    <div class="row">
      <div class="col-12">
        <h3>Associação entre Grupos e Tipos</h3>
        <p class="text-muted">Selecione um tipo e configure os grupos associados.</p>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-7">
        <label for="tipo-grupo"><strong>Tipo de grupo</strong></label>
        <select id="tipo-grupo" class="form-control" v-model="tipoSelecionado" :disabled="loading || salvando" @change="selecionarTipo">
          <option value="">Selecione um tipo</option>
          <option v-for="tipo in tiposGrupo" :key="tipo.id" :value="String(tipo.id)">{{ tipo.nome }}</option>
        </select>
      </div>
    </div>

    <template v-if="loading">
      <div class="row"><div class="col-12 text-center py-5"><div class="loader mx-auto"></div><h4 class="mt-3">Carregando...</h4></div></div>
    </template>

    <template v-else-if="tipoSelecionado">
      <div class="row mb-3">
        <div class="col-md-6"><strong>{{ selecionados.length }}</strong> de <strong>{{ grupos.length }}</strong> grupos associados</div>
        <div class="col-md-6 text-md-right"><span v-if="alterado" class="text-warning">Alterações não salvas</span></div>
      </div>
      <div class="row mb-3">
        <div class="col-md-8"><input v-model="busca" type="text" class="form-control" placeholder="Buscar por nome ou código..."></div>
        <div class="col-md-4 text-md-right mt-2 mt-md-0">
          <label class="marcar-todos"><input type="checkbox" :checked="todosVisiveisMarcados" @change="marcarVisiveis($event.target.checked)"> Marcar todos os exibidos</label>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-hover tabela-associacoes">
          <thead><tr><th>Associado</th><th>ID</th><th>Nome</th><th>Código</th><th>Plataforma</th><th>Tipo</th><th>Ativo</th></tr></thead>
          <tbody>
            <tr v-for="grupo in gruposFiltrados" :key="grupo.id" :class="{ 'linha-selecionada': selecionados.includes(Number(grupo.id)) }">
              <td>
                    <input
                    type="checkbox"
                    class="checkbox-associacao"
                    :checked="selecionados.includes(Number(grupo.id))"
                    @change="alterarGrupo(grupo.id, $event.target.checked)"
                    />
              </td>
              <td>{{ grupo.id }}</td><td>{{ grupo.nome }}</td><td>{{ grupo.codigo }}</td>
              <td>{{ grupo.plataforma || 'WHATSAPP' }}</td><td>{{ grupo.tipo === 'CANAL' ? 'Canal' : 'Grupo' }}</td>
              <td>{{ Number(grupo.ativo) === 1 ? 'Sim' : 'Não' }}</td>
            </tr>
            <tr v-if="!gruposFiltrados.length"><td colspan="7" class="text-center">Nenhum grupo encontrado.</td></tr>
          </tbody>
        </table>
      </div>
      <div class="row"><div class="col-12 text-right button-bar">
        <base-button type="secondary" fill :disabled="!alterado || salvando" @click="cancelar">Cancelar</base-button>
        <base-button type="primary" fill :disabled="!alterado || salvando" @click="salvar">{{ salvando ? 'Salvando...' : 'Salvar alterações' }}</base-button>
      </div></div>
    </template>
  </div>
</template>

<script>
import BootstrapToggle from 'vue-bootstrap-toggle'

export default {
  name: 'WhatsappAssociacoes',
  data() {
    return {
      tiposGrupo: [], grupos: [], tipoSelecionado: '', tipoAnterior: '',
      selecionados: [], originais: [], busca: '', loading: true, salvando: false,
      requisicao: 0
    }
  },
  computed: {
    gruposFiltrados() {
      const termo = this.busca.trim().toLowerCase()
      return this.grupos.filter(g => (`${g.nome || ''} ${g.codigo || ''}`).toLowerCase().includes(termo))
    },
    todosVisiveisMarcados() {
      return this.gruposFiltrados.length > 0 && this.gruposFiltrados.every(g => this.selecionados.includes(Number(g.id)))
    },
    alterado() {
      const ordenar = lista => [...lista].map(Number).sort((a, b) => a - b).join(',')
      return ordenar(this.selecionados) !== ordenar(this.originais)
    }
  },
  methods: {
    async iniciar() {
      this.loading = true
      try {
        const [tipos, grupos] = await Promise.all([
          this.$aws.get('whatsapp/tipogrupo'),
          this.$aws.get('whatsapp/grupo')
        ])
        this.tiposGrupo = Object.values(tipos.data || {})
        this.grupos = Object.values(grupos.data || {})
      } catch (error) {
        console.error(error)
        this.$swal('Ops!', 'Erro ao carregar tipos ou grupos.', 'error')
      } finally { this.loading = false }
    },
    async selecionarTipo(event) {
      const novoTipo = event.target.value
      if (this.alterado) {
        const resultado = await this.$swal({
          title: 'Descartar alterações?', text: 'Há vínculos ainda não salvos.',
          icon: 'warning', showCancelButton: true, confirmButtonText: 'Descartar', cancelButtonText: 'Voltar'
        })
        if (!resultado.value && !resultado.isConfirmed) {
          this.tipoSelecionado = this.tipoAnterior
          return
        }
      }
      this.tipoAnterior = novoTipo
      this.busca = ''
      this.selecionados = []
      this.originais = []
      if (!novoTipo) return
      this.loading = true
      const idRequisicao = ++this.requisicao
      try {
        const response = await this.$aws.get(`whatsapp/tipogrupo/${novoTipo}/grupos`)
        if (idRequisicao !== this.requisicao) return
        const ids = response.data.vinculados || []
        this.selecionados = ids.map(Number)
        this.originais = [...this.selecionados]
      } catch (error) {
        console.error(error)
        this.tipoSelecionado = ''
        this.tipoAnterior = ''
        this.$swal('Ops!', 'Erro ao consultar os vínculos.', 'error')
      } finally { if (idRequisicao === this.requisicao) this.loading = false }
    },
    alterarGrupo(id, marcado) {
      id = Number(id)
      if (marcado) {
        if (!this.selecionados.includes(id)) this.selecionados.push(id)
      } else { this.selecionados = this.selecionados.filter(item => item !== id) }
    },
    marcarVisiveis(marcar) {
      const ids = this.gruposFiltrados.map(g => Number(g.id))
      if (marcar) this.selecionados = [...new Set([...this.selecionados, ...ids])]
      else this.selecionados = this.selecionados.filter(id => !ids.includes(id))
    },
    cancelar() { this.selecionados = [...this.originais] },
    async salvar() {
      if (!this.tipoSelecionado || !this.alterado || this.salvando) return
      this.salvando = true
      try {
        await this.$aws.put(`whatsapp/tipogrupo/${this.tipoSelecionado}/grupos`, {
          grupos: this.selecionados
        })
        this.originais = [...this.selecionados]
        this.$swal('Ok!', 'Associações salvas com sucesso.', 'success')
      } catch (error) {
        console.error(error)
        this.$swal('Ops!', 'Erro ao salvar associações.', 'error')
      } finally { this.salvando = false }
    }
  },
  mounted() { this.iniciar() }
}
</script>

<style lang="scss" scoped>
.whatsapp-associacoes {
  h3 { margin: 0 0 12px; }
  .tabela-associacoes { width: 100%; }
  .tabela-associacoes th { font-weight: bold; white-space: nowrap; }
  .tabela-associacoes td { vertical-align: middle; }
  .marcar-todos { cursor: pointer; }
  .button-bar { border-top: 2px solid #FC7D59; padding-top: 2em; margin-top: 2em; }
  .loader { width: 45px; height: 45px; border: 4px solid #eee; border-top-color: #FC7D59; border-radius: 50%; animation: girar 0.8s linear infinite; }
  @keyframes girar { to { transform: rotate(360deg); } }
}
.checkbox-associacao {
  width: 19px;
  height: 19px;
  cursor: pointer;
  accent-color: #FC7D59;
}
.tabela-associacoes {
  tbody tr.linha-selecionada {
    background-color: #d4edda !important;

    &:hover {
      background-color: #c3e6cb !important;
    }

    td {
      background-color: transparent !important;
    }
  }
}
</style>
